import type { FileUploadRestrictions } from '../types';

import {
  DEFAULT_MAX_FILE_SIZE,
  DEFAULT_MAX_NUMBER_OF_FILES,
} from '../constants';
import { fileUploadRestrictionsSchema } from '../validations';

/**
 * Parses raw upload restriction input into a validated shape for Uppy.
 * Falls back to defaults when input is null, not an object, or fails validation.
 *
 * @param input - Raw input (typically from `FileUploadRestrictions` props).
 * @returns Validated restrictions with `allowedFileTypes`, `maxFileSize`, and
 *   `maxNumberOfFiles`. Uses defaults (20 MB, 1 file) when parsing fails.
 */
export function parseFileUploadRestrictions(
  input: unknown,
): FileUploadRestrictions {
  if (input == null || typeof input !== 'object') {
    return {
      allowedFileTypes: undefined,
      maxFileSize: DEFAULT_MAX_FILE_SIZE,
      maxNumberOfFiles: DEFAULT_MAX_NUMBER_OF_FILES,
    };
  }

  const result = fileUploadRestrictionsSchema.safeParse(input);

  if (result.success) {
    return result.data;
  }

  return {
    allowedFileTypes: undefined,
    maxFileSize: DEFAULT_MAX_FILE_SIZE,
    maxNumberOfFiles: DEFAULT_MAX_NUMBER_OF_FILES,
  };
}
